// similar functions to SCSS mixins

import { css } from 'styled-components';

export const mediaMaxSizes = {
  xsmall: 320,
  phone: 480,
  tabsmall: 768,
  tab: 960,
  desktopsmall: 1225,
  desktop: 1280,
};

export const mediaq = {
  xsmall: (...args) => css`
    @media (max-width: ${mediaMaxSizes.xsmall}px) {
      ${css(...args)}
    }
  `,
  phone: (...args) => css`
    @media (max-width: ${mediaMaxSizes.phone}px) {
      ${css(...args)}
    }
  `,
  phonePortraite: (...args) => css`
    @media (max-width: ${mediaMaxSizes.phone}px) and (orientation: portrait) {
      ${css(...args)}
    }
  `,
  phoneLandscape: (...args) => css`
    @media (max-height: ${mediaMaxSizes.phone}px) and (orientation: landscape) {
      ${css(...args)}
    }
  `,
  tabsmall: (...args) => css`
    @media (max-width: ${mediaMaxSizes.tabsmall}px) {
      ${css(...args)}
    }
  `,
  tab: (...args) => css`
    @media (max-width: ${mediaMaxSizes.tab}px) {
      ${css(...args)}
    }
  `,
  desktopsmall: (...args) => css`
    @media (max-width: ${mediaMaxSizes.desktopsmall}px) {
      ${css(...args)}
    }
  `,
  desktop: (...args) => css`
    @media (max-width: ${mediaMaxSizes.desktop}px) {
      ${css(...args)}
    }
  `,
  smallScreen: (...args) => css`
    @media (max-height: 1100px) {
      ${css(...args)}
    }
  `,
};

export function truncate(width) {
  return `
		width: ${width};
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	`;
}

export function getScreenWidth() {
  // Get Screen dimensions for mobile device
  const screenWidth = window.screen.availWidth;

  // Get browser window dimensions for desktop
  const windowWidth = window.innerWidth;

  // Check user device
  const isMobile = navigator.userAgent.indexOf('mobi') != -1 ? true : false;

  // use different objects of width and height depending on user device
  const refWidth = isMobile ? screenWidth : windowWidth; // if user agent is mobi, then refer to screen dimensions;

  return refWidth;
}

export function getScreenHeight() {
  // Get Screen dimensions for mobile device
  const screenHeight = window.screen.availHeight;

  // Get browser window dimensions for desktop
  const windowHeight = window.innerHeight;

  // Check user device
  const isMobile = navigator.userAgent.indexOf('mobi') != -1 ? true : false;

  // use different objects of width and height depending on user device
  const refHeight = isMobile ? screenHeight : windowHeight; // if user agent is mobi, then refer to screen dimensions;

  return refHeight;
}
